<template>
  <div class="box">
    <div class="boxTop">
      <div class="jichuxinxi">
        <div class="jcTitle">
          基础信息
        </div>
        <div class="phoneBox">
          <div class="phoneTex">手机号</div>
          <div class="phoneNum">{{phone}} <span @click="telG">修改</span></div>
        </div>
        <div class="passBox">
          <div class="passTex">修改登录密码</div>
          <div class="passNum">建议您定期更改密码以保护账户安全 <span @click="passG">修改</span></div>
        </div>
      </div>
    </div>
    <div class="boxBottom">
      <div class="Bjichuxinxi">
        <div class="BjcTitle">
          基础信息
        </div>
        <div class="BphoneBox">
          <div class="BphoneTex">微信账号</div>
          <div class="BphoneNum">
            {{wxName}}
            <span @click="jieB" v-if="!state">解绑</span>
            <a
              v-else
              style="text-underline: none;text-decoration: none;"
              :href="'https://open.weixin.qq.com/connect/qrconnect?appid=wxb42c7bf35b56e38f&redirect_uri=http://ysb.emof.cn/home/zhszBanKuai/zhaqBanKuai&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'">
              <span>绑定</span>
            </a>
          </div>
        </div>
<!--        <div class="BpassBox">-->
<!--          <div class="BpassTex">QQ账号</div>-->
<!--          <div class="BpassNum">绑定后，可使用QQ账号直接登录益书宝发布或参与活动 <span>立即绑定</span></div>-->
<!--        </div>-->
      </div>
    </div>
    <!--    修改手机号-->
    <el-dialog
      title="更换手机号"
      width="35%"
      :visible.sync="outerVisible"
      center
      custom-class="waiMask"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="phoneLogin">
          <div class="inputBox">
            <el-form-item prop="tel">
              <el-input
                v-model.number="ruleForm.tel"
                placeholder="请输入手机号"
              >
<!--                <i slot="prefix" class="iconfont iconicon-user iconColor"></i>-->
              </el-input>
            </el-form-item>
          </div>
          <div class="inputBox">
            <el-form-item prop="code">
              <el-input
                v-model.number="ruleForm.code"
                placeholder="请输入验证码"
              >
<!--                <i slot="prefix" class="iconfont iconshouji iconColor"></i>-->
              </el-input>
            </el-form-item>
            <div v-show="show" class="getCode" @click="getCode">获取验证码</div>
            <div v-show="!show" class="getCodeE">{{count}}s</div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="tiJ" type="primary" @click="tjYanz">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title="修改登录密码"
      :visible.sync="innerVisible"
      center
      :append-to-body="true"
      custom-class="neiMask"
    >
      <el-form :model="findPass" :rules="ruleFind" ref="findPass" label-width="100px">
        <el-form-item label="旧密码" prop="oldPass">
          <el-input type="password" v-model="findPass.oldPass" placeholder="请输入旧密码" auto-complete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="findNewPass">
          <el-input type="password" v-model="findPass.findNewPass" placeholder="请输入新密码" auto-complete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="findAgainPass">
          <el-input type="password" v-model="findPass.findAgainPass" placeholder="请再次输入新密码" auto-complete="off">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="queR" type="primary" @click="adNewPass">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title="验证身份"
      :visible.sync="innerVisibleTwo"
      center
      append-to-body
      custom-class="neiMask"
    >
      <div style="width: 100%;text-align: center;margin-right: 20px;">为了保证您的账号安全，请先进行身份验证</div>
      <h3 style="width: 100%;text-align: center;margin-bottom: 20px;">{{phone}}</h3>
      <el-form :model="findPass" :rules="ruleFind" ref="findPass" label-width="">
        <el-form-item label="" prop="">
          <el-input type="text" v-model="findPass.telNew" placeholder="请输已绑定的手机号" auto-complete="off">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="queR" type="primary" @click="qdnewTel">下一步</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "zhaqBanKuai",
    data() {
      return {
        phone: '',
        phoneP:'',
        num: '',
        wxName: '',
        state: false,
        outerVisible: false,
        innerVisible: false,
        innerVisibleTwo: false,
        show: true, // 60秒倒计时
        count: '',
        timer: null,
        ruleForm: {
          tel: '',
          code: ''
        },
        rules: {
          tel: [
            {required: true, message: '请输入手机号'},
            {validator: this.validateTel,}
          ],
          code: [
            {required: true, message: '请输入验证码'},
            {type: 'number', min: 6, message: '验证码为6位数字',}
          ],
        },
        // 输入密码
        findPass: {
          oldPass:'',
          findNewPass: '',
          findAgainPass: '',
          telNew: ''
        },
        // 在输入密码
        ruleFind: {
          oldPass:[
            {required: true, message: '请输入旧密码', trigger: 'blur'},
          ],
          findNewPass: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
            {validator: this.validateFindPass, trigger: 'blur'}
          ],
          findAgainPass: [
            {required: true, message: '请再次输入密码', trigger: 'blur'},
            {validator: this.validatePass2, trigger: 'blur'}
          ],
        },
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (!this.user) {
        this.$router.push("/login")
      }

      this.code = this.$tools.getQueryString('code')
      console.log(this.code)

      if (this.code) {
        this.weixinbd()
      }
      this.$emit('setAct', 2)
      // 获取用户信息
      this.getuserinfo()
    },
    methods: {
      // 提交验证手机号验证码
      tjYanz() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$api.apiAdmin.Changephone({
              mid: this.user.mid,
              phone: this.ruleForm.tel,
              code: this.ruleForm.code,
              oldphone:this.findPass.telNew
            }).then(res => {
              console.log(res)
              this.$messageSuccess(res.msg)
              this.outerVisible = false
              this.getuserinfo()
            }).catch(res => {
              this.$messageError(res.msg);
              this.outerVisible = false
            });
          } else {
            return false;
          }
        })
      },
      // 确定修改密码
      adNewPass() {
        this.$refs.findPass.validate((valid) => {
          if (valid) {
            this.$api.apiAdmin.ChangePass({
              mid: this.user.mid,
              oldpass: this.$md5(this.findPass.oldPass),
              password: this.$md5(this.findPass.findNewPass),
              repassword: this.$md5(this.findPass.findAgainPass),
            }).then(res => {
              this.$messageSuccess(res.msg);
              this.$store.state.user = null
              this.innerVisible = false
              setTimeout(() => {
                this.$router.push('/login')
              }, 500)
            }).catch(res => {
              this.$messageError(res.msg);
            })
          } else {
            return false;
          }
        })
      },
      // 确定修改新手机号
      qdnewTel() {
        if(String(this.findPass.telNew) === String(this.phoneP)){
          this.innerVisibleTwo = false
          this.outerVisible = true
        }else {
          this.$messageError('请输入正确的手机号');
        }
        // let reg = /^1[3456789]\d{9}$/;
        // if (this.findPass.telNew === '') {
        //   this.$messageError('请输入手机号');
        //   return
        // } else if (!reg.test(this.findPass.telNew)) {
        //   this.$messageError('请输入正确的手机号');
        //   return
        // } else {
        //   this.$api.apiAdmin.Changephone({
        //     phone: this.findPass.telNew,
        //     mid: this.user.mid
        //   }).then(res => {
        //     this.$messageSuccess(res.msg);
        //     this.$store.state.user = null
        //     this.outerVisible = false
        //     this.innerVisible = false
        //     this.innerVisibleTwo = false
        //     setTimeout(() => {
        //       this.$router.push('/login')
        //     }, 500)
        //   }).catch(res => {
        //     this.$messageError(res.msg);
        //   })
        // }
      },
      // 获取验证码
      getCode() {
        let reg = /^1[3456789]\d{9}$/;
        if (this.ruleForm.tel === '') {
          this.$messageError('请输入手机号');
          return
        } else if (!reg.test(this.ruleForm.tel)) {
          this.$messageError('请输入正确的手机号');
          return
        } else {
          this.$messageSuccess('发送成功请稍等！');
          this.getCodeTime()
          this.$api.apiContent.sendNum({
            phone: this.ruleForm.tel
          }).then(res => {
            this.qianM = res.data
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }
      },
      // 验证码倒计时
      getCodeTime() {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
      },
      // 修改手机号
      telG() {
        this.innerVisibleTwo = true
      },
      // 修改密码
      passG() {
        this.innerVisible = true
      },
      // 微信绑定
      weixinbd() {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api.apiContent.bdWx({
          code: this.code,
          mid: this.user.mid
        }).then(() => {
          loading.close();
          // this.wxName = res.data
          this.state = false

        }).catch(res => {
          loading.close();
          this.$messageError(res.msg);
        })
      },
      // 微信解绑
      jieB() {
        this.$api.apiAdmin.DelWechat({
          mid: this.user.mid
        }).then(res => {
          this.$messageSuccess(res.msg);
          this.wxName = ''
          this.state = true
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
// 获取用户信息
      getuserinfo() {
        this.$api.apiAdmin.Getinfo({
          mid: this.user.mid
        }).then(res => {
          this.phoneP = res.data.mphone
          var mphone = res.data.mphone.substr(0, 3) + '****' + res.data.mphone.substr(7);
          this.phone = mphone
          if(res.data.unionid !== ''){
            this.wxName = res.data.wechatname
            this.state = false
          }else {
            this.wxName = ''
            this.state = true
          }
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      validateFindPass(rule, value, callback) {
        console.log(value)
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6) {
          callback(new Error('密码至少为6位以上的字母或数字'));
        } else {
          if (this.findPass.findAgainPass !== '') {
            this.$refs.findPass.validateField('findAgainPass');
          }
          callback();
        }
      },
      validatePass2(rule, value, callback) {
        console.log(value)
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.findPass.findNewPass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
      validateTel(rule, value, callback) {
        let reg = /^1[3456789]\d{9}$/;
        if (value === '') {
          callback(new Error('请输入手机号'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%;
    padding-bottom: 100px;

    .boxTop {
      width: 100%;
      display: flex;
      justify-content: center;

      .jichuxinxi {
        width: 780px;

        .jcTitle {
          padding-left: 20px;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-left: 2px solid #0089ff;
        }

        .phoneBox {
          margin-left: 50px;
          display: flex;
          justify-content: flex-start;
          margin-top: 40px;

          .phoneTex {
            font-size: 14px;
            color: #fff;
            padding-left: 22px;
            background: url('../../../../assets/images/dianhua.png') no-repeat left center;
            background-size: 14px 14px;
          }

          .phoneNum {
            color: #fff;
            font-size: 14px;
            margin-left: 140px;

            span {
              color: #0089ff;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }

        .passBox {
          margin-left: 50px;
          display: flex;
          justify-content: flex-start;
          margin-top: 40px;

          .passTex {
            font-size: 14px;
            color: #fff;
            padding-left: 22px;
            background: url('../../../../assets/images/suozi.png') no-repeat left center;
            background-size: 15px 14px;
          }

          .passNum {
            color: #fff;;
            font-size: 14px;
            margin-left: 100px;

            span {
              color: #0089ff;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }
      }
    }

    .boxBottom {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 50px;

      .Bjichuxinxi {
        width: 780px;

        .BjcTitle {
          padding-left: 20px;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          border-left: 2px solid #0089ff;
        }

        .BphoneBox {
          margin-left: 50px;
          display: flex;
          justify-content: flex-start;
          margin-top: 40px;

          .BphoneTex {
            font-size: 14px;
            color: #fff;
            padding-left: 22px;
            background: url('../../../../assets/images/wxIcon.png') no-repeat left center;
            background-size: 18px 18px;
          }

          .BphoneNum {
            color: #fff;
            font-size: 14px;
            margin-left: 100px;

            span {
              color: #0089ff;
              margin-left: 10px;
              cursor: pointer;
            }
          }
        }

        .BpassBox {
          margin-left: 50px;
          display: flex;
          justify-content: flex-start;
          margin-top: 40px;

          .BpassTex {
            font-size: 14px;
            color: #fff;
            padding-left: 22px;
            background: url('../../../../assets/images/qqIcon.png') no-repeat left center;
            background-size: 16px 15px;
          }

          .BpassNum {
            color: #fff;;
            font-size: 14px;
            margin-left: 100px;

            span {
              color: #fff;
              margin-left: 10px;
              padding: 4px 18px;
              border-radius: 20px;
              background-color: #0089ff;
              cursor: pointer;
            }
          }
        }
      }
    }

    .phoneLogin {
      width: 100%;

      .inputBox {
        width: 100%;
        position: relative;

        .getCode {
          position: absolute;
          right: 12px;
          font-size: 12px;
          top: 8px;
          color: #0089ff;
          cursor: pointer;
        }

        .getCodeE {
          position: absolute;
          right: 12px;
          font-size: 12px;
          top: 12px;
          color: #fff;
          cursor: pointer;
        }


        input {
          width: 348px;
          height: 52px;
          border-radius: 8px;
          border: solid 1px #e2e2e1;
        }
      }
    }
  }
</style>
